'use client'

import React, { useState } from 'react'

import { KeyboardKey } from './keyboard-key'

interface KeyboardLayoutProps {
  onKeyPress?: (value: string) => void
  isNumeric?: boolean
}

const NumericLayout = ({
  onKeyPress,
}: {
  onKeyPress?: (value: string) => void
}) => (
  <div className="grid w-full grid-cols-3 gap-1 overflow-hidden bg-gray-50 p-2">
    {['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '⌫'].map((key) => (
      <KeyboardKey key={key} value={key} onClick={onKeyPress} />
    ))}
  </div>
)

const QwertyLayout = ({
  onKeyPress,
}: {
  onKeyPress?: (value: string) => void
}) => {
  const [showSpecialChars, setShowSpecialChars] = useState(false)

  const mainRows = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '+', '⌫'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['@', 'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/'],
  ]

  const specialRows = [
    ['@', '#', '$', '%', '&', '*', '(', ')', '-', '+'],
    ['!', '?', ',', '.', '/', ':', ';', '"', "'"],
  ]

  const rows = showSpecialChars ? specialRows : mainRows

  return (
    <div className="flex w-full flex-col gap-1 bg-gray-50 p-2">
      {rows.map((row, i) => (
        <div key={i} className="flex w-full justify-center gap-1">
          {row.map((key) => (
            <KeyboardKey
              key={key}
              value={key}
              onClick={onKeyPress}
              className="w-full capitalize"
            />
          ))}
        </div>
      ))}
      <div className="flex justify-center gap-1">
        <KeyboardKey value=" " onClick={onKeyPress} className="w-full" />
      </div>
    </div>
  )
}

const KeyboardLayout = ({
  onKeyPress,
  isNumeric = false,
}: KeyboardLayoutProps) => {
  return isNumeric ? (
    <NumericLayout onKeyPress={onKeyPress} />
  ) : (
    <QwertyLayout onKeyPress={onKeyPress} />
  )
}

export { KeyboardLayout }
